export const abilityModifier = ability => Math.floor(ability / 2 - 5)
